/* eslint-disable no-use-before-define */
import React from 'react'
import { Fields, isString, getId } from '../../twd'

var updating = false

export default ({field, form, error, label, style, ...props}) => {

    let err = form.errors && form.errors[field.name]
    let id = getId()
    return (
    <React.Fragment>
    {label && <label htmlFor={id}>{label}</label>}

    <div
        className={'form-group ' + (err || error ? ' has-error': '')}
        style={Object.assign({whiteSpace:'nowrap'},style)}
    >
    <Fields.SearchCusip
        id={id}
        dataName="advanced-screener-corp-symbol"

        onClear={() => {
            form.setFieldValue(field.name, '')

            updating = true
            setTimeout(() => { updating=false }, 500)
        }}

        onSelect={(a) => {
            let v = isString(a) ? a : a.value
            form.setFieldValue(field.name, v)

            updating = true
            setTimeout(() => { updating=false }, 500)
            return v
        }}

        filter={a => a.type==='C' && a.symbol && a.issuer}
        map={a => ({
            value:a.symbol,
            label: `${a.symbol} - ${a.issuer}`
        }) }

        name={field.name}
        value={field.value}

        {...field}
        {...props}

        onBlur={({keyword}) => {
            if (updating) return

            let a = (keyword || '').trim()
            if (!a) return

            form.setFieldValue(field.name, a)
            return a
        }}
    />
    { err && <label className="field-status has-error">{err}</label> }
    </div>

    </React.Fragment>)
}



// WEBPACK FOOTER //
// ./src/advanced-screener/search-form/symbol-field.js